"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PcbDrawingSchema = void 0;
const zod_1 = require("zod");
const Circle_1 = require("./Circle");
const Arc_1 = require("./Arc");
const Curve_1 = require("./Curve");
const Polygon_1 = require("./Polygon");
const Pad_1 = require("./Pad");
const TextBox_1 = require("./TextBox");
const Rect_1 = require("./Rect");
const Segment_1 = require("./Segment");
const Text_1 = require("./Text");
const Track_1 = require("./Track");
const Via_1 = require("./Via");
const Zone_1 = require("./Zone");
exports.PcbDrawingSchema = zod_1.z.discriminatedUnion('type', [
    Arc_1.ArcSchema,
    Circle_1.CircleSchema,
    Curve_1.CurveSchema,
    Pad_1.PadSchema,
    Polygon_1.PolygonSchema,
    Rect_1.RectSchema,
    Segment_1.SegmentSchema,
    TextBox_1.TextBoxSchema,
    Text_1.TextSchema,
    Track_1.TrackSchema,
    Via_1.ViaSchema,
    Zone_1.ZoneSchema,
]);
//# sourceMappingURL=PcbDrawing.js.map